import { Button, Input } from '@platform/design-system';
import { useEffect, useId, useRef, useState } from 'react';
import styles from './ScanField.module.css';

export type ScanFieldProps = {
  label: string;
  helperText: string;
  submitLabel: string;
  busy: boolean;
  onScan: (code: string) => void;
  onTextChange?: (text: string) => void;
};

export const ScanField = ({ label, helperText, submitLabel, busy, onScan, onTextChange }: ScanFieldProps) => {
  const [value, setValue] = useState('');
  const field = useRef<HTMLInputElement>(null);
  const helperId = useId();

  useEffect(() => {
    if (!busy) field.current?.focus();
  }, [busy]);

  const changeText = (text: string) => {
    setValue(text);
    onTextChange?.(text);
  };

  return (
    <form
      className={styles['form']}
      onSubmit={(event) => {
        event.preventDefault();
        const scanned = value.trim();
        if (scanned === '') return;
        onScan(scanned);
        changeText('');
      }}
    >
      <span className={styles['scan']}>
        <Input
          ref={field}
          label={label}
          aria-describedby={helperId}
          value={value}
          autoComplete="off"
          spellCheck={false}
          enterKeyHint="send"
          onChange={(event) => {
            changeText(event.target.value);
          }}
        />
        <Button type="submit" variant="outline" disabled={busy}>
          {submitLabel}
        </Button>
      </span>
      <span id={helperId} className={styles['helper']}>
        {helperText}
      </span>
    </form>
  );
};
